export default __webpack_public_path__ + "static/media/placeholder.299ec9e8.svg";